<script lang="ts" setup>
import { ROUTE_NAMES } from '@/router/conf';
import useIsSettingsView from '@/composables/useIsSettingsView';
import useAuthenticatedQuery from '@/composables/apiServices/useAuthenticatedQuery';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { userIndex } = useAuthenticatedQuery();
const { isMatchingSettingsRoute } = useIsSettingsView();
</script>

<template>
  <RouterLink
    :to="
      isMatchingSettingsRoute
        ? { name: ROUTE_NAMES.BASE_LAYOUT, params: { userIndex } }
        : { name: ROUTE_NAMES.COMPOSE, params: { userIndex } }
    "
    class="bg-secondary-container d-flex justify-center align-center ga-2 rounded py-2 px-4 flex-grow-1 text-decoration-none font-weight-medium"
    data-test-id="compose-link"
    sentry-unmask
  >
    <VIcon size="small">{{
      isMatchingSettingsRoute ? 'mdi-arrow-left' : 'mdi-pencil-outline'
    }}</VIcon>
    {{ isMatchingSettingsRoute ? t('folderDef.inbox') : t('common.compose') }}
  </RouterLink>
</template>

<style lang="scss">
.compose-button__link {
  padding: 0 1rem;
}
</style>
